import { Card, CardContent } from "@/components/ui/card";
import type { ProjectFinancialSummary } from "@/generated/types";
import MetricCard from "./MetricCard";
import Currency from "./Currency";

interface FinancialSummaryProps {
  summary: ProjectFinancialSummary;
}

export default function FinancialSummary({ summary }: FinancialSummaryProps) {
  const showOverdue = summary.totalOverdue > 0;

  return (
    <Card>
      <CardContent className="p-8">
        <h3 className="text-lg font-light text-primary-950 dark:text-white mb-6">
          RESUMO
        </h3>
        <div
          className={`grid grid-cols-1 sm:grid-cols-2 gap-6 ${
            showOverdue ? "lg:grid-cols-4" : "lg:grid-cols-3"
          }`}
        >
          <MetricCard
            label="VALOR TOTAL"
            value={summary.totalContractsValue}
          />
          <MetricCard label="PAGO" value={summary.totalPaid} status="success" />
          <MetricCard
            label="PENDENTE"
            value={summary.totalPending}
            valueClassName="text-primary-800 dark:text-primary-200"
          />
          {showOverdue && (
            <MetricCard
              label="ATRASADO"
              value={summary.totalOverdue}
              status="overdue"
            />
          )}
        </div>
        <div className="mt-6 pt-6 border-t border-primary-200 dark:border-primary-800">
          <div className="flex justify-between items-center">
            <span className="text-xs uppercase tracking-widest text-primary-600 dark:text-primary-400">
              SALDO RESTANTE
            </span>
            <Currency value={summary.balance} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
